import React, { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Fab
      color="primary"
      onClick={handleScrollToTop}
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        backgroundColor: 'orange',
        color: 'white',
        opacity: showButton ? 1 : 0,
        transform: showButton ? 'scale(1)' : 'scale(0)',
        transition: 'opacity 0.3s ease, transform 0.3s ease',
        visibility: showButton ? 'visible' : 'hidden',
        '&:hover': {
          backgroundColor: 'darkorange',
        },
      }}
    >
      <KeyboardDoubleArrowUpIcon />
    </Fab>
  );
};

export default ScrollToTopButton;
